import React from 'react';
import Toolbar from '@atlassian/jira-aais-timeline-toolbar/src/ui/container/index.tsx';
import type { ToolbarItem } from '@atlassian/jira-aais-timeline-toolbar/src/ui/container/types.tsx';
import FullscreenButton from '@atlassian/jira-fullscreen-button/src/index.tsx';
import { JiraBottomRightCornerOutlet } from '@atlassian/jira-layout-controller/src/ui/bottom-right-corner/outlet/index.tsx';
import { RoadmapTimelineMode } from '@atlassian/jira-software-roadmap-timeline-table-kit/src/ui/chart-overlay/timeline-mode/index.tsx';
import { isVisualRefreshEnabled } from '@atlassian/jira-visual-refresh-rollout/src/feature-switch/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import {
	useInteractionMetrics,
	TIMELINE_MODE_CHANGED,
} from '../../../../common/utils/interaction-metrics.tsx';
import { useTimelineUI } from '../../../../controllers/timeline-ui/index.tsx';
import TodayButton from '../../toolbar/today-button/index.tsx';

// NOTE: We are confident that the queried elements with the given id will always be HTMLElement | null
const getFullscreenRefs = (): (HTMLElement | null)[] => {
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
	return Array.from(document.querySelectorAll('[data-fullscreen-id]')) as (HTMLElement | null)[];
};

export const ChartOverlayButton = () => {
	const interactionMetrics = useInteractionMetrics();

	const [, { setTimelineMode }] = useTimelineUI();

	const toolbarItems: ToolbarItem[] = [
		...(isVisualRefreshEnabled()
			? [
					{
						id: 'today-button',
						element: <TodayButton />,
						showDivider: !(isVisualRefreshEnabled() && fg('visual-refresh_drop_4')),
						isVisible: true,
					},
				]
			: []),
		{
			id: 'timeline-mode-switcher',
			element: (
				<RoadmapTimelineMode
					onClick={(mode) => {
						interactionMetrics[TIMELINE_MODE_CHANGED].start();
						setTimelineMode(mode);
					}}
				/>
			),
			showDivider: isVisualRefreshEnabled() && fg('visual-refresh_drop_4'),
		},
		...(fg('blu-5747-fullscreen-in-nav-header')
			? []
			: [
					{
						id: 'fullscreen-button',
						element: (
							<FullscreenButton
								testId="business-timeline.ui.timeline-view.chart-overlay.overlay-button.fullscreen-button"
								withContainerStyles={false}
								getCustomRefs={getFullscreenRefs}
								isSubtle={isVisualRefreshEnabled()}
							/>
						),
					},
				]),
	];

	const toolbar = <Toolbar items={toolbarItems} />;

	return (
		<JiraBottomRightCornerOutlet orderFromRight={2} id="business-timeline-overlay">
			{toolbar}
		</JiraBottomRightCornerOutlet>
	);
};
